import { Router } from '@angular/router';
import { Grid } from '../../../../shared/Models/grid';
import { ActionColumn, ActionItem } from '../../../../shared/Models/columns';
import { Part } from '../../../Models/Part';
import { PartsService } from '../../../Services/parts.service';
import { TemplateRef } from '@angular/core';
import { createBasePartsGridConfig } from './base-parts-grid.config';

export function createPartsOverviewGridConfig(
  router: Router,
  partsService: PartsService,
  partRowDetail: TemplateRef<any>,
  onEdit: (row: Part) => void,
  onDelete: (row: Part) => void,
  onAddStock: (row: Part) => void,
  onView: (row: Part) => void
): Grid {
  const actionColumn = <ActionColumn>{
    name: 'global.actions',
    prop: null,
    type: ActionColumn.type,
    sortable: false,
    translate: true,
    actionItems: [
      <ActionItem> {
        icon: 'fa fa-eye fa-lg',
        tooltip: 'global.view',
        onclick: onView,
        showCallback: (row: Part) => row,
        btnClass: 'ripple light'
      },
      <ActionItem> {
        icon: 'fa fa-pencil fa-lg',
        tooltip: 'global.edit',
        onclick: onEdit,
        showCallback: (row: Part) => row,
        btnClass: 'ripple light ms-1'
      },
      <ActionItem>{
        icon: 'fa fa-remove fa-lg',
        tooltip: 'global.remove',
        onclick: onDelete,
        btnClass: 'ripple light ms-1'
      },
      <ActionItem>{
        icon: 'fa fa-plus fa-lg',
        tooltip: 'global.addStock',
        onclick: onAddStock,
        btnClass: 'ripple light ms-1'
      },
    ]
  };

  return createBasePartsGridConfig({
    router,
    partsService,
    partRowDetail,
    showButton: true,
    simpleSearch: true,
    additionalColumns: [actionColumn]
  });
} 